import { FC } from 'react';
import { ServiceProviderDetailsDto } from 'src/generated/services/TFinancialApi';
import { useTourContext } from 'src/presentations/guided-tours';
import { RateCardProviderCard } from './RateCardProviderCard';

interface RateCardProviderListProps {
  rateCards: ServiceProviderDetailsDto[];
}

export const RateCardProviderList: FC<RateCardProviderListProps> = ({ rateCards }) => {
  const { appTour } = useTourContext();
  const providerTour = appTour.registerTour('rate-card-provider-selection');

  return (
    <div id={providerTour.registerStep('serviceProviderSelection', [], rateCards.length > 0)} className='-mx-8 xl:-mx-12 flex flex-wrap'>
      {rateCards.map((item) => (
        <div key={`ratecard-${item.id}`} className='px-8 xl:px-12 w-1/4 mb-16 xl:mb-30 xl:min-h-[8.4375rem]'>
          <RateCardProviderCard item={item} />
        </div>
      ))}
    </div>
  );
};
